<app-auth-container>
  <form *ngIf="!isVerify" class="container-details flex flex-col items-center p-4">
    <!-- Logo & Heading -->
    <div class="signUp-heading-details flex justify-center items-center gap-2">
      <p class="signUp-heading">Sign In</p>
      <div class="logo">
        <img src="assets/images/signup_image.svg" alt="Logo" />
      </div>
    </div>

    <!-- Dynamic Input Field -->
    <div [formGroup]="form" class="signUp-details flex justify-center items-center flex-col mt-6 w-100">
      <div class="signUp-field w-100">
        <div class="signUp-label">
          <!-- <label for="dynamic-input">Email/Phone Number</label> -->
          <label for="dynamic-input">Email</label>
        </div>
        <div class="input-container flex items-center gap-1 flex-nowrap">
          <!-- Dynamic Icon -->
          <div *ngIf="showIcon">
            <img
              [src]="inputType === 'email' ? 'assets/images/alternate_email_green.svg' : 'assets/images/call_green.svg'"
              alt="Icon"
            />
          </div>

          <!-- Dynamic Input -->
          <div class="w-100 country-select" [class.flex]="inputType === 'mobile' && showIcon">
            <lib-country-list 
              *ngIf="inputType === 'mobile' && showIcon"
              [selectedCountryConfig]="selectedCountryConfig" 
              [allowedCountryCodes]="uniqueAvailableCodes"
              [countryListConfig]="countryListConfig"
              (onCountryChange)="onCountryChange($event)">
            </lib-country-list>
            <span
              *ngIf="inputType === 'mobile' && showIcon">|</span>
            <input
              id="dynamic-input"
              class="border-none outline-none bg-transparent w-100"
              type="text"
              placeholder="Enter here"
              formControlName="email"
              />
              <!-- [(ngModel)]="inputValue" -->
              <!-- (keyup)="validateInput()" -->
              <!-- [ngModelOptions]="{ standalone: true }" -->
          </div>
        </div>

        <!-- Error Message -->
        <!-- <div *ngIf="!isInputValid && errorMessage" class="error-message text-red-500 mt-2">
          {{ errorMessage }}
        </div> -->

        <!-- temporary -->
        <div *ngIf="form.controls['email'].touched && form.controls['email'].hasError('required')" class="error-message text-red-500 mt-2">
          Email is required
        </div>
        <div *ngIf="form.controls['email'].touched && form.controls['email'].hasError('email')" class="error-message text-red-500 mt-2">
          Please enter a valid email.
        </div>
      </div>
    </div>

    <!-- Next Button -->
    <div class="button mt-4 w-100 pointer">
      <app-button text="Next" type="submit" (onClick)="onNext()" />
    </div>

    <!-- Sign Up Link -->
    <div class="alreadyuser mt-4">
      <p>
        Don’t have an account?
        <span class="text-primary" (click)="onSignUp()">Sign Up</span>
      </p>
    </div>
  </form>

  <!-- OTP Verification Component -->
  <app-otp-verification *ngIf="isVerify" (dataEvent)="receiveData($event)" [inputValue]="inputValue" btnText="Sign In" [isLoginOrSignup]="false" [email]="email" [phoneNumber]="mobileNumber" />
</app-auth-container>
